// GET /api/payments/receipt?paymentIntent=pi_xxx -> { ready, amount?, receiptPdfUrl?, receiptHostedUrl? }
// Covers donations and invoice payments (both charge a plain PaymentIntent
// via /create-payment-intent / /me/invoices/*). Membership 5787 has its
// own analogous endpoint — see api/membership/membershipApi.js#getMembershipReceipt.
// The receipt PDF is generated asynchronously by the backend's Stripe
// webhook, so `ready: false` is a normal "still processing" response, not
// an error — the caller is expected to poll a few times.
const baseUrl = () => process.env.REACT_APP_BASE_URL || '';

export const getPaymentReceipt = async (paymentIntentId) => {
  const res = await fetch(`${baseUrl()}/payments/receipt?paymentIntent=${encodeURIComponent(paymentIntentId)}`);
  if (!res.ok) {
    throw new Error(`Could not check receipt status (${res.status})`);
  }
  return res.json();
};
